import { useSelector } from "react-redux";
import { useMemo } from "react";
import { getBugReportSlice, getBugReportStack } from "./selectors";
import { ErrorEntity } from "./types";

// eslint-disable-next-line import/prefer-default-export
export const useBugReportSlice = () => useSelector(getBugReportSlice);

export const useBugReportErrorsStack = (): ErrorEntity[] =>
  useSelector(getBugReportStack);

export const useUnreportedBugsCount = (): number => {
  const errors = useBugReportErrorsStack();

  const getReportedBugsCount = (): number => {
    const unreportedBugs = errors.filter((err) => !err.bugReported);
    return unreportedBugs.length;
  };

  return useMemo(getReportedBugsCount, [errors]);
};

export const useHasFlowioAnyBugs = (): boolean => {
  const errors = useBugReportErrorsStack();
  return !!errors.length;
};
